import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { StorageService } from '../services/storage.service';
import { ToastService } from '../services/toast.service';
import { LoaderService } from '../services/loader.service';
import { ConnectionService } from '../services/connection.service';
import { ReCaptchaV3Service } from 'ngx-captcha';
@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  RegisterForm:FormGroup;
  showpassword: boolean = false;
  passwordtoogleicon: any = 'eye';
  data:any;
  loader: boolean = false;

  constructor( private fb: FormBuilder,
    private storage: Storage,
    private router: Router,
    private authService: AuthenticationService,
    private strg: StorageService,
    private toast: ToastService,
    private _loader: LoaderService,
    private apiService: ConnectionService,
    private recaptchaV3Service: ReCaptchaV3Service) {
      this.authService.authState.subscribe(res => { 
        if(res === true){
          this.router.navigate(['/login']);
        }
      });
    }
  
  get firstname() {
    return this.RegisterForm.get("firstname");
  }
  get lastname() {
    return this.RegisterForm.get("lastname");
  }
  get email() {
    return this.RegisterForm.get('email');
  }
  get password() {
    return this.RegisterForm.get('password');
  }
  get termscondition() {
    return this.RegisterForm.get('termscondition');
  }

  validationErrorMessages = {
    'firstname': {
      'required': 'First Name is required',
      'maxlength': 'First Name cant be longer than 100 characters'
    },
    'lastname': {
      'required': 'Last Name is required',
      'maxlength': 'Last Name cant be longer than 100 characters'
    },
    'email': {
      'required': 'Email is required',
      'pattern': 'Please enter a valid email address'
    },
    'password': {
      'required': 'Password is Required.',
      'pattern': 'The password must contain atleast 8 characters with the combination of upper and lower case alphanumberic\'s and alteast a special character'
    },
  }

  formValidationErrors = {
    'firstname': '',
    'lastname': '',
    'email': '',
    'password': '',
  }

  ngOnInit() {
    this.RegisterForm = this.fb.group({
      firstname: ['', [Validators.required, Validators.maxLength(100)]],
      lastname: ['', [Validators.required, Validators.maxLength(100)]],
      email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]],
      // password: ['', [Validators.required, Validators.pattern("[0-9a-z-A-Z@.#*$!?&+-/]*")]],
      password: ['', [Validators.required, Validators.pattern("(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\\S+$).{8,}")]],
      termscondition: [null, Validators.required]
    });
    this.RegisterForm.valueChanges.subscribe(res => this.logValidationErrorsOnChange() );
  }

  logValidationErrorsOnChange(group: FormGroup = this.RegisterForm){
    Object.keys(group.controls).forEach((key: string)=>{
      const getFormControlKey = group.get(key);
      this.formValidationErrors[key] = '';
      if(getFormControlKey && !getFormControlKey.valid && (getFormControlKey.touched || getFormControlKey.dirty)){
        const errorMsg = this.validationErrorMessages[key];
        for(const errorKey in getFormControlKey.errors){
          if(errorKey){
            if(errorKey === 'required'){
              this.formValidationErrors[key] = errorMsg[errorKey]
              break;
            }else{
              this.formValidationErrors[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  togglepassword() {
    this.showpassword = !this.showpassword;
    // if (this.passwordtoogleicon == 'eye') {
    //   this.passwordtoogleicon = "eye-off";
    // }
    // else {
    //   this.passwordtoogleicon = "eye";
    // }
  }
  
  submitFormOnEnter(event){
    if(event.keyCode === 13 && !this.RegisterForm.invalid){
      this.SubmitRegistrationForm();
    }
  }

  SubmitRegistrationForm(){
    this.recaptchaV3Service.execute("6LcCPnckAAAAADZJkE0MecTtIFQup2y_4pa67Gpv", 'registration', (token) => {
      this.apiService.checkRecaptchaResponse(String(token)).subscribe(res => {
        if (res) {
          let dataa = JSON.parse(res.data);
          if (dataa.success && dataa.score > 0.5 && dataa.action === "registration") {
            this.data = {
              firstName: this.RegisterForm.get('firstname').value,
              lastName: this.RegisterForm.get('lastname').value,
              email: this.RegisterForm.get('email').value,
              password: this.RegisterForm.get('password').value,
              check: this.RegisterForm.get('termscondition').value
            }
            console.log(this.data,"this is registration data");
            this._loader.showLoader("Please Wait...");
            this.loader = true;
            this.authService.signUpAndGetAccessToken(this.data).subscribe(res => {
              this.loader = false;
              this._loader.hideLoader();
              console.log(res, "response of api");
              if (res.status == "CREATED") {
                this.strg.setStoreData("userObj", res.data).then(() => {         
                  this.toast.showToast('Congrats user created succesfully!'); 
                  // this.router.navigate(['/login']);         
                  ///////////////////
                  let userData = {
                    email: this.RegisterForm.get('email').value,
                    pwd: this.RegisterForm.get('password').value
                  }
                  this.loader = true;
                  this.authService.getInsAccessToken(userData).subscribe(res => {
                    this.loader = false;
                    this._loader.hideLoader();
                    if (res.access_token) {
                      this.storage.ready().then(() => {
                        this.storage.set('insAccessToken', res.access_token).then(() => {
                          this.storage.set('insRefreshToken', res.refresh_token).then(() => {
                            // this.toast.showToast('login succesfull!');  
                            // this.router.navigate(['/quote-upgrade']);
                              // this.authService.getUserDetails(userData.email).subscribe(res => { //for direct ref
                              this.authService.getUserDetails().subscribe(res => {
                                if(res.status === "OK"){
                                  let data;
                                  if(res.data.user){
                                    data = res.data.user;
                                  }else{
                                    data = res.data;
                                  }
                                  this.strg.setStoreData("userObj", data).then(() => {
                                    console.log("save userobj", data);
                                    setTimeout(()=>{
                                      this.authService.authState.next(true);
                                      this.router.navigate(['/login']);
                                    },1000)
                                  });
                                }
                              })
                              // this.router.navigateByUrl(String(this.returnUrl), { replaceUrl: true });
                          });
                        });
                      });
                    }
                  }, err => {
                    this._loader.hideLoader();
                    this.loader = false;
                    console.log('insurance login error', JSON.stringify(err));
                    console.log('insurance login error', err.error.error_description);
                    this.toast.showToast(err.error.error_description);
                  });
                  ///////////////////     
                });
              }
            }, err => {
              this.loader = false;
              this._loader.hideLoader();
              if (err.status == 400) {
                this.toast.showToast(err.error.message);
              } else if (err.status == 409) {
                this.toast.showToast("Email already in use. Please try another one. Thank You");
              } else {
                this.toast.showToast(err.error?.message ? err.error?.message : err.error?.error_description)
                console.log('signuperr', err);
              }
            });
          }
        }
      }, err => { });
    });
  }
}
